import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=2eb9e581&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb9e581')) {
      api.createRecord('2eb9e581', component.options)
    } else {
      api.reload('2eb9e581', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=2eb9e581&", function () {
      api.rerender('2eb9e581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vug0To52u0oP/JS/pricehelp.vue"
export default component.exports